import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Lottie from 'lottie-react';

const STORAGE_KEY = 'erohome_age_verified';

export const AgeGate: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    const verified = localStorage.getItem(STORAGE_KEY);
    if (!verified) setVisible(true);
    fetch('/18.json')
      .then((r) => r.json())
      .then(setAnimationData)
      .catch(() => null);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/90 backdrop-blur-md px-4"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 24 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            className="relative max-w-md w-full rounded-2xl overflow-hidden border border-white/10"
            style={{
              background:
                'linear-gradient(135deg, rgba(26,10,14,0.98) 0%, rgba(10,10,10,0.98) 100%)',
              boxShadow: '0 0 60px rgba(139,0,0,0.3), 0 0 120px rgba(139,0,0,0.1)',
            }}
          >
            {/* Topo decorativo */}
            <div className="h-1 w-full bg-gradient-to-r from-transparent via-accent-gold to-transparent" />

            <div className="p-8 flex flex-col items-center text-center gap-6">
              {/* Lottie 18+ */}
              {animationData && (
                <div className="w-32 md:w-40">
                  <Lottie animationData={animationData} loop autoplay />
                </div>
              )}

              
              {/* Título */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-2">
                  Verificação de Idade
                </h2>
                <p className="text-white/70 text-sm leading-relaxed">
                  Este site contém conteúdo exclusivo para adultos.
                  <br />
                  Você confirma que tem{' '}
                  <span className="text-accent-gold font-semibold">
                    18 anos ou mais
                  </span>
                  ?
                </p>
              </div>

              {/* Botões */}
              <div className="flex flex-col sm:flex-row gap-3 w-full">
                <button
                  onClick={handleAccept}
                  className="liquid-button flex-1 py-3 font-semibold"
                >
                  Sim, tenho 18+
                </button>
                <button
                  onClick={handleDecline}
                  className="flex-1 py-3 rounded-lg border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all duration-300 text-sm font-medium"
                >
                  Não, sair
                </button>
              </div>

              {/* Disclaimer */}
              <p className="text-white/30 text-xs leading-relaxed border-t border-white/10 pt-4">
                <strong className="text-white/50">Disclaimer Erohome:</strong>{' '}
                Todo o conteúdo disponibilizado nesta plataforma é exclusivamente
                para adultos (+18). Ao acessar, você declara ter idade legal em
                seu país de residência e concorda com os{' '}
                <a
                  href="#"
                  className="underline hover:text-white/60 transition-colors"
                >
                  Termos de Uso
                </a>{' '}
                e a{' '}
                <a
                  href="#"
                  className="underline hover:text-white/60 transition-colors"
                >
                  Política de Privacidade
                </a>
                . A Erohome não se responsabiliza pelo acesso indevido de
                menores de idade.
              </p>
            </div>

            {/* Rodapé decorativo */}
            <div className="h-1 w-full bg-gradient-to-r from-transparent via-red-900 to-transparent" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AgeGate;
